import { render, staticRenderFns } from "./account-msg.vue?vue&type=template&id=3aae524b&scoped=true"
import script from "./account-msg.vue?vue&type=script&lang=js"
export * from "./account-msg.vue?vue&type=script&lang=js"
import style0 from "./account-msg.vue?vue&type=style&index=0&id=3aae524b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae524b",
  null
  
)

export default component.exports